import { parseProject, type Project } from "@proof/core";
export class AuthoringSession {
  private current: Project;
  private past: Project[] = [];
  private future: Project[] = [];
  constructor(
    definition: unknown,
    private limit = 100,
  ) {
    this.current = parseProject(definition);
    if (!Number.isInteger(limit) || limit < 1 || limit > 1000)
      throw new Error("Invalid undo limit");
  }
  get project() {
    return structuredClone(this.current);
  }
  get canUndo() {
    return !!this.past.length;
  }
  get canRedo() {
    return !!this.future.length;
  }
  replace(definition: unknown) {
    this.current = parseProject(definition);
    this.past = [];
    this.future = [];
    return this.project;
  }
  update(definition: unknown) {
    const next = parseProject(definition);
    if (next.id !== this.current.id)
      throw new Error("Use replace when switching documents");
    if (JSON.stringify(next) === JSON.stringify(this.current))
      return this.project;
    this.past.push(this.current);
    this.past = this.past.slice(-this.limit);
    this.future = [];
    this.current = next;
    return this.project;
  }
  undo() {
    const previous = this.past.pop();
    if (previous) {
      this.future.push(this.current);
      this.current = previous;
    }
    return this.project;
  }
  redo() {
    const next = this.future.pop();
    if (next) {
      this.past.push(this.current);
      this.current = next;
    }
    return this.project;
  }
}
